<template>
  <div>
    <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between">
      <h4 class="font-weight-bold">Documentação</h4>
    </div>
    <load mode="table" v-if="loading" />
    <form v-else @submit.prevent="cadastarDocumentacao" ref="addItem">
      <div class="row">
        <form-select
          v-model="documentacao"
          :itens="$root.arrays.acolhimento_documentacao"
          label="Qual Documentação?"
          grid="6"
          :required="true"
        />
        <form-select
          v-model="acao"
          :required="true"
          :itens="$root.arrays.acolhimento_documentacao_acao"
          label="Ação?"
          grid="6"
        />
      </div>
      <div class="row">
        <form-input
            label="Detalhe da documentação"
            v-model="detalhe_documentacao"
            v-show="mostrarDetalheDocumentacao"
            :required="mostrarDetalheDocumentacao"
            maxlength="100"
        />
      </div>
      <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end">
        <button class="btn btn-primary m-0" data-style="zoom-in" type="submit">
          Cadastrar
        </button>
      </div>
    </form>
    <div class="row">
      <h3 class="px-3">Listagem de documentos</h3>
      <div class="col-12" v-if="item.documentacao.length > 0">
        <table class="table table-sm border">
          <tbody v-if="item.documentacao">
            <tr
              v-for="(documento, index) in item.documentacao"
              :key="documento.id"
            >
              <td scope="col">
                {{
                  verificarValueArray(
                    documento.documento,
                    $root.arrays.acolhimento_documentacao
                  )
                }}
              </td>
              <td scope="col">
                {{
                  verificarValueArray(
                    documento.acao,
                    $root.arrays.acolhimento_documentacao_acao
                  )
                }}
              </td>
              <td scope="col">
                <button
                  title="Excluir Conta Bancaria"
                  @click="excluirDocumento(documento.id, index)"
                  class="btn px-2 mb-0 btn-danger btn-xs"
                >
                  <i class="mdi mdi-close"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12" v-else>
        <h4 class="text-secondary">
          <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
          Nada salvo aqui.
        </h4>
      </div>
    </div>
    <h3>Dados Jurídicos</h3>
    <form @submit.prevent="submit">
      <div class="row">
        <form-input
          v-model="dadosJuridicos.numero_processo"
          label="Número do Processo"
          grid="6"
        />
        <form-input
          v-model="dadosJuridicos.numero_guia_acolhimento"
          label="Número da Guia de Acolhimento"
          grid="6"
        />
        <form-input
          v-model="dadosJuridicos.numero_guia_desligamento"
          label="Número da Guia de Desligamento"
          grid="6"
        />
        <form-input
          v-model="dadosJuridicos.nome_tribunal"
          label="Nome do Tribunal"
          grid="6"
        />
        <form-input
          v-model="dadosJuridicos.nome_comarca"
          label="Nome da Comarca"
        />
        <form-input
          v-model="dadosJuridicos.nome_responsavel_caso"
          label="Nome da Vara Especializada responsável pelo caso"
        />
        <form-input
          v-model="dadosJuridicos.endereco_vara"
          label="Endereço da Vara Especializada"
        />
        <form-input
          v-model="dadosJuridicos.pessoa_referencia_vara"
          label="Pessoa de referência na Vara Especializada"
        />
        <form-input
          v-model="dadosJuridicos.telefone_pessoa_referencia"
          label="Telefones da pessoa de referência na Vara Especializada"
        />
      </div>
      <div class="row pt-4 px-0 d-flex justify-content-end">
        <div class="col-auto px-2 text-right">
          <button class="btn btn-success btn-submit" type="submit">
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      documentacao: "",
      acao: "",
      detalhe_documentacao: "",
      loading: false,
      dadosJuridicos: {},
    };
  },
  watch: {
    item() {
      if (this.item.dadosJuridicos != null) {
        this.dadosJuridicos = this.item.dadosJuridicos;
      }
    },
    'documentacao'(novoValor) {
      if (novoValor !== 16) {
          this.detalhe_documentacao = null; // ou "" se preferir string vazia
      }
    }
  },
  mounted() {
    if (this.item.dadosJuridicos != null) {
      this.dadosJuridicos = this.item.dadosJuridicos;
    }
  },
  computed: {
    mostrarDetalheDocumentacao() {
      return this.documentacao === 16;
    },
  },
  methods: {
    submit() {
      this.item.dadosJuridicos = this.dadosJuridicos;
      this.$emit("submit");
    },
    cadastarDocumentacao() {
      this.loading = true;
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(
          `api/dashboard/acolhimento/storedocumentacao`,
          {
            detalhe_documentacao: this.detalhe_documentacao,
            documento: this.documentacao,
            acao: this.acao,
            acolhimento_id: this.item.id,
          },
          {
            header: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (event) => {
              let progress = Math.round((event.loaded * 100) / event.total);
              this.progressCompleted = progress;
            },
          }
        )
        .then((response) => {
          ladda.stop();

          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.$emit("reload");
        })
        .finally(() => {
          this.documentacao = "";
          this.acao = "";
          this.loading = false;
        });
    },
    excluirDocumento(id) {
      swal.fire({
        text: "Aguarde a ação ser finalizada.",
        icon: "warning",
        showConfirmButton: false,
        timer: 1500,
      });
      axios
        .get(`api/dashboard/acolhimento/documentacao/excluir/${id}`)
        .then((response) => {
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.$emit("reload");
        });
    },
    verificarValueArray(value, array, valueIsArray = false) {
      if (valueIsArray && value) {
        var a = "";
        for (var i = 0; i < value.length; i++) {
          const result = array.filter((item) => item.id == value[i]);
          a += result[0].value + (i < value.length - 1 ? "," : "");
        }

        return a;
      } else {
        const result = array.filter((item) => item.id == value);
        return result[0] ? result[0].value : "";
      }
    },
  },
};
</script>
